export const MAX_DESCRIPTION_CHAR_COUNT = 48;
